export default __webpack_public_path__ + "static/media/hint.14af02d0.ogg";